const STATUS = {
  idle: { label: "CONTAINMENT STABLE", color: "text-[#B57BFF]" },
  init: { label: "AUTHORIZING", color: "text-[#FF9900]" },
  uploading: { label: "CONCEPT UPLOADING", color: "text-[#00F0FF]" },
  complete: { label: "PETRI DISH READY", color: "text-[#00FF88]" },
};

const Panel = ({ title, children, testid }) => (
  <div data-testid={testid} className="panel p-4">
    <div className="overline mb-3">{title}</div>
    {children}
  </div>
);

export const Telemetry = ({ phase, progress, logs }) => {
  const s = STATUS[phase];
  const density = phase === "complete" ? "00.0" : (98.4 - progress * 98.4).toFixed(1);
  return (
    <div className="flex flex-col gap-4 h-full min-h-0">
      <Panel title="System status" testid="system-status-panel">
        <div data-testid="system-status-label" className={`font-display text-3xl font-bold tracking-wide ${s.color}`}>{s.label}</div>
      </Panel>
      <Panel title="Specimen readouts" testid="readouts-panel">
        <div className="grid grid-cols-2 gap-3 font-mono text-xs">
          <Readout k="DARK MASS DENSITY" v={`${density}%`} />
          <Readout k="UPLOAD" v={`${Math.round(progress * 100)}%`} testid="readout-upload" />
          <Readout k="CORE TEMP" v={phase === "uploading" ? "-271.4°C" : "-273.1°C"} />
          <Readout k="SPECIMEN" v={phase === "complete" ? "#809-X" : "--"} />
        </div>
        <div className="flex items-end gap-[3px] h-12 mt-4">
          {Array.from({ length: 28 }).map((_, i) => (
            <span key={i} className="eq-bar" style={{ animationDelay: `${(i % 7) * 0.11}s`, animationDuration: phase === "uploading" ? "0.35s" : "1.4s" }} />
          ))}
        </div>
      </Panel>
      <Panel title="Event log" testid="event-log-panel">
        <ul className="font-mono text-xs space-y-1.5 overflow-hidden">
          {logs.map((l, i) => (
            <li key={`${l.t}-${i}`} className="log-line text-[#8B949E]">
              <span className="text-[#00F0FF]/70">[{l.t}]</span> <span className="text-[#F0F6FC]">{l.m}</span>
            </li>
          ))}
        </ul>
      </Panel>
    </div>
  );
};

const Readout = ({ k, v, testid }) => (
  <div className="border border-cyan-500/15 rounded p-2 bg-black/30">
    <div className="text-[10px] text-[#8B949E] tracking-widest">{k}</div>
    <div data-testid={testid} className="text-[#F0F6FC] text-base mt-1">{v}</div>
  </div>
);
